<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5 22.3L22.5 18.5C22.7 18.3 22.7 17.7 22.5 17.5L19.5 14.5C19.3 14.3 18.7 14.3 18.5 14.5L17 15.8C17 15.8 16.3 16.9 12.1 12.7L11.6 12.2C7.29995 7.89997 8.49995 7.49998 8.49995 7.49998L9.49995 6.49998C9.69995 6.29998 9.69995 5.69998 9.49995 5.49998L6.49995 2.49998C6.29995 2.29998 5.69995 2.29998 5.49995 2.49998L1.69995 6.49998C1.69995 6.49998 7.49995 16.1 18.5 22.3Z"
      class="stroke-current"
    />
  </svg>
</template>
